import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  margin-top: 15px;
  padding: 0 0 10px;
`;

export const EmailNote = styled.div`
width: 100%,
backgroundColor: #f5f6f7,
padding: 10px
`;

export const UserRole = styled.div`
  position: relative;
`;

export const Box = styled.div`
  margintop: 15px;
  width: 100%;
  position: relative;
  padding-bottom: 20px;
`;

export const Title = styled.span`
  font-size: 26px;

  &:before {
    font-family: 'telusdings' !important;
    padding-right: 10px; 
    content: "\\E057";
  }
`;
